<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />

<div class="dynamic-form">
  <form [formGroup]="formGroup">
    <dynamic-material-form
      [group]="formGroup"
      [layout]="formLayout"
      [model]="formModel"
      (blur)="onBlur($event)"
      (change)="onChange(formGroup)"
      (focus)="onFocus($event)"
      (matEvent)="onMatEvent($event)"
      [getLanguage]="getLanguage"
    ></dynamic-material-form>
    @if (this.hasRequested === 'true' && recaptchaSiteKey && isRequestAccountEnabled$ | async) {
    <div class="request-captcha" #myCaptcha>
      <re-captcha
        formControlName="recaptchaReactive"
        class="recaptcha"
        (resolved)="resolved($event)"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
        [siteKey]="recaptchaSiteKey"
      ></re-captcha>
      @if (recaptchaError) {
      <div class="recaptcha-error-text">
        {{ 'requestAccount.recaptchaError' | cxTranslate }}
      </div>
      }
    </div>
    }
  </form>
</div>
